import React from 'react';
import CharacterVectorsObject from 'game/scenes/test/CharacterVectorsObject';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function CharacterVectorsObjectPage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [CharacterVectorsObject],
            physics: {
              arcade: {
                gravity: { y: 0 },
                debug: true,
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
